
<p-dialog id = "orderdetailviewerdialog" [style]="{'width': '95%', 'min-width': '95vw', 'min-height': '450px'}" 
[contentStyle]="{'height': 'auto','width': 'auto', 'overflow': 'auto' }"
styleClass = "order-viewer-dialog"
header="Order Detail Viewer" [(visible)]="isOpenClose" modal="true"
(onHide)="closeDialogbox()"
scrollTop="true"
maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times"  appendTo="body" showEffect="fade"
[focusOnShow]="false">
<div>
      <mat-accordion #accordion="matAccordion" multi>

          <!--Filter Code  -->
          <mat-expansion-panel [expanded]="expandedPanel[0]">
            <mat-expansion-panel-header >
                <span  class="panel-title">Order Viewer Filter </span> 
            </mat-expansion-panel-header>
            <mat-panel-description>
              <div class="panel-description">
                <div class="panel-left-section">
                  <mat-chip-listbox aria-label="filter">
                    <span>
                        <label for="filter">
                            <i class="fa fa-filter" id="filter"></i>
                        </label>
                        <mat-chip  selected color="green" matTooltip="Date" [matTooltipShowDelay]="1000"
                                matTooltipPosition="after" id="Date"> 
                                Date: {{todate}}
                            </mat-chip>
                            <mat-chip  selected color="green" matTooltip="OrderId" [matTooltipShowDelay]="1000"
                                matTooltipPosition="after" id="OrderId"> 
                                OrderId: {{OrderId}}
                            </mat-chip>
                    </span>
                </mat-chip-listbox>
                </div>
                <div class="panel-right-section">
                  <section class="example-section">
                    <mat-checkbox [(ngModel)]="checkedMatchUsingSymbol" (change)="toggleMatchSymbol($event)">Match using Symbol </mat-checkbox>
                    <mat-checkbox [(ngModel)]="checkedTrade">Show Trade Data </mat-checkbox>
                    <mat-checkbox [(ngModel)]="checkedRoute">Show Route Data </mat-checkbox>
                  </section>
                </div>
              </div>
            </mat-panel-description>
          </mat-expansion-panel>
        </mat-accordion>
      
        @if(checkedAccordationView) {
         <mat-accordion #accordion="matAccordion" multi>
            <!-- CAT Grid Code   -->
            <mat-expansion-panel [expanded]="expandedPanel[0]">
              <mat-expansion-panel-header>
                  <span  class="panel-title">CAT </span> 
              </mat-expansion-panel-header>
              <mat-panel-description>
                <div class="ui-grid-col-12  nopadding table-container table-full-min-width">
                  @if(isCATdatasetLoading) {
                    <div class="example-loading-shade">
                        <mat-spinner></mat-spinner>
                      </div>
                  }
                  <app-turbo-table 
                  [GridColumns]="CATGridCols" 
                  [Dataset]="CATdataset"    
                  [TotalRecords]=CATdataset.length
                  >
                  </app-turbo-table>
                </div>
              </mat-panel-description>
            </mat-expansion-panel>
          </mat-accordion>
        }
          <!-- Order Grid Code   -->
        <mat-expansion-panel  [expanded]="expandedPanel[0]">
          <mat-expansion-panel-header>
            <mat-panel-title >
              <span  class="panel-title">Order </span> 
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-panel-description>
            <div class="ui-grid-col-12  nopadding table-container table-full-min-width">
              @if(isOrderdatasetLoading) {
                <div class="example-loading-shade">
                  <mat-spinner></mat-spinner>
                </div>
              }
              <app-turbo-table
               [GridColumns]="OrderGridCols" 
               [Dataset]="Orderdataset"     
               [TotalRecords]=Orderdataset.length
               >
              </app-turbo-table>
            </div>
          </mat-panel-description>
        </mat-expansion-panel>
        
        <!-- Trade Grid Code   -->
        @if(checkedTrade) {
          <mat-expansion-panel [expanded]="expandedPanel[0]">
            <mat-expansion-panel-header>
              <span  class="panel-title">Trade </span> 
            </mat-expansion-panel-header>
            <mat-panel-description>
              <div class="col-lg-12 nopadding table-container table-full-min-width">
                @if(isTradedatasetLoading) {
                  <div class="example-loading-shade">
                      <mat-spinner></mat-spinner>
                    </div>
                }
                <app-turbo-table 
                [GridColumns]="TradeGridCols" 
                [Dataset]="Tradedataset"
                [TotalRecords]=Tradedataset.length
                >
                </app-turbo-table>
              </div>
            </mat-panel-description>
          </mat-expansion-panel>
        }
         <!-- Route Grid Code   -->
        @if(checkedRoute) {
          <mat-expansion-panel [expanded]="expandedPanel[0]">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span  class="panel-title">Route </span> 
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-panel-description>
              <div class="ui-grid-col-12  nopadding table-container table-full-min-width">
                @if(isRoutedatasetLoading) {
                  <div class="example-loading-shade">
                      <mat-spinner></mat-spinner>
                    </div>
                }
                <app-turbo-table 
                [GridColumns]="RouteGridCols" 
                [Dataset]="Routedataset"    
                [TotalRecords]=Routedataset.length
                >
                </app-turbo-table>
              </div>
            </mat-panel-description>
          </mat-expansion-panel>
        }
      
          <div class="d-grid gap-2 d-md-block float-right">
            <button type="button" id="export-current-btn" 
            [matTooltip]="this.UserService.enableFileExport()?
                    'Export':'Export service is disabled'"
            class="btn btn-primary btn-sm footer-buttons exportBtn" 
            (click)="exportToCSV('Current')" label="Export Current Page"> <i class="fa fa-download footer-button-icon"></i>Export Current Page
            </button>
            <button type="button" id="export-all-btn" 
            [matTooltip]="this.UserService.enableFileExport()?
                    'Export':'Export service is disabled'"
            class="btn btn-primary btn-sm footer-buttons exportBtn" 
            (click)="exportToCSV('All')" label="Export All Records"> <i class="fa fa-download footer-button-icon"></i>Export All Records
            </button>
            <button type="button" class="btn btn-danger btn-sm footer-buttons footer-close-button"
            [matTooltip]="this.UserService.enableFileExport()?
                    'Export':'Export service is disabled'"
              (click)="isOpenClose=false;" label="Close"> <i class="fa fa-times footer-button-icon"></i>Close</button>
            </div>
  </div>
 </p-dialog>